import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from '../../translate-module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {CompanyService} from '../../services/company.service';
import { AppDataService } from '../../services';
import { MeusCertificadosComponent } from './meus-certificados.component';
@NgModule({
  declarations: [
MeusCertificadosComponent

  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,

    BrowserModule.withServerTransition({
      appId: 'angular-universal-firebase'
    }),


  ],
  providers: [
    CompanyService,
    AppDataService


  ],
  exports: [
    MeusCertificadosComponent
    ]
})
export class MeusCertificadosModules { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/Meus-Certificados/meus-certificados.module.ts